import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { MemberService } from '../services/member.service';
import { map, take } from 'rxjs/operators';

export const managementGuard: CanActivateFn = () => {
    const memberService = inject(MemberService);
    const router = inject(Router);

    return memberService.isAgent$.pipe(
        take(1),
        map(isAgent => {
            if (isAgent) {
                return router.createUrlTree(['my']);
            }
            return true;
        }),
    );
};
